import React from 'react'
import {createRoot} from 'react-dom/client'
import '../src/assets/styles/main.css'
import App from './App'
import * as serviceWorker from './serviceWorker'

const rootElement = document.getElementById('main')
const root = createRoot(rootElement)

root.render(
  <React.StrictMode>
    <App/>
  </React.StrictMode>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
